import {
    INIT_MY_PAGE,
} from './types';

import {
    AUTH_SOURCE_TYPE_PULSE,
    AUTH_SOURCE_TYPE_SPID,
} from '../constants';

const initialState = {
    init: true,
    authenticateUser: true,
    apiHost: CONFIG.myPage.apiHost,
    publication: CONFIG.myPage.publication,
    title: CONFIG.myPage.applicationTitle,
    theme: CONFIG.myPage.publication,
    internalActions: [],
    allowedAuthSources: [AUTH_SOURCE_TYPE_PULSE, AUTH_SOURCE_TYPE_SPID],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case INIT_MY_PAGE:
            return { ...state, ...({ ...initialState, ...action.payload }) };
        default:
            return state;
    }
};
